import React from 'react';
import { withRouter } from "react-router-dom";
import './Transcript-history.css';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import {constants} from './../../constants';
import { isEqual,isEmpty } from 'lodash';
import { updateTranscriptHistoryFlag,
         setTransactionHistorySuccess,setTotalTranscriptAmount,
         getExamSeriesSuccess,getInstitutionsSuccess,
         getTranscriptsCost,updatePayFlag,getInstitutionsError,
         setRequestId,updateHistoryPayNavFlag,resetStateTransitionFlags,
         setDeviceType,getTranscriptHistory,getTranscriptSummary,getTermsAndConditions,
         resetHistoryFlags,resetCommonDataData,setNamesFromHistoryAndModified } from '../../redux-building-blocks/actions';
import moment from 'moment';
import Modal from './../shared/modal/Modal';
import { Spinner } from 'react-bootstrap';
import UtilityService from './../../services/utility.service';
import MulesoftDataService from './../../services/mulesoftData.services';
export class TranscriptHistory extends React.Component{
    constructor(props){
        super(props);
        this.state={ overlay: false,spinner: false};
    }
    componentDidMount(){
        const {setDeviceType,terms,getTermsAndConditions,transcriptRates,
               getTranscriptsCost,resetStateTransitionFlags,
               userProfile} = this.props;
        localStorage.removeItem('transcript');
        let deviceType = navigator.userAgent,
        isMobile = constants.deviceRegEx.test(deviceType);
        if(!isMobile){
         isMobile = window.matchMedia("only screen and (max-width: 480px)").matches;   
        }        

        if(!isEmpty(this.props.transactionId)) {
            this.props.resetCommonDataData();
        } 
        if(isEmpty(userProfile)){
            this.setState({spinner: true});
        }else{ 
            this.setState({spinner: true});
            if(isEmpty(terms)){
                getTermsAndConditions(uuidv4());        
            }
            if(isEmpty(transcriptRates.transcriptsCost)) {
                getTranscriptsCost(uuidv4());
            }
            this.loadHistory();
            resetStateTransitionFlags();
        }
        setDeviceType(isMobile);
    }
    componentDidUpdate(previousProps) {
        const {transactionHistory,historyResponseSuccess,transactionSummary,
               summaryResponseErr,historyResponseErr} = this.props.tHistory;        
        if (!isEqual(previousProps.userProfile, this.props.userProfile)) {        
            this.loadHistory();
            if(isEmpty(this.props.terms)){
                this.props.getTermsAndConditions(uuidv4());        
            }
            if(isEmpty(this.props.transcriptRates && this.props.transcriptRates.transcriptsCost)) {
                this.props.getTranscriptsCost(uuidv4());
            }
        }
        if(!isEqual(previousProps.tHistory.transactionHistory, transactionHistory) || historyResponseSuccess){
            const sortedARN = this.orderNumSort(transactionHistory),
                  sortedSeries = this.commonSort(sortedARN,"history")  ;
            this.props.setTransactionHistorySuccess(sortedSeries);
            this.setState({body:sortedSeries,spinner:false});
            this.props.resetHistoryFlags();
        }
        if(!isEqual(previousProps.tHistory.transactionSummary,transactionSummary) || this.props.tHistory.summaryResponseErr){
            if(!summaryResponseErr && !isEmpty(transactionSummary)){           
                transactionSummary.section = "summary";
                this.commonSort(transactionSummary,"summary");                
            }else{
                this.props.resetHistoryFlags();
                window.scrollTo(0,0);                
            }
        }
        if(!isEqual(historyResponseErr,previousProps.tHistory.historyResponseErr)){
            this.props.resetHistoryFlags();            
            this.setState({spinner: false,errorMsg:constants.APP_MESSAGE.API_RETRIVE_ERROR});
        }        
    }
    
    loadHistory = () => this.props.getTranscriptHistory({uid:this.props.userProfile?.uid,tId:uuidv4()});

    orderNumSort = rec =>{
        let reN = /[^0-9]/g,extractedNum=[],sorted=[];
        for(let x of rec){
            let n = parseInt(x?.applicationReferenceNumber.replace(reN, ""), 10);
            extractedNum.push(n?.toString().slice(2));
        }
        extractedNum = extractedNum.sort((a,b)=>{return b-a})
        for(let y of extractedNum){
            let f = rec?.filter(r=>r.applicationReferenceNumber.includes(y));
            if(f.length){sorted.push(f[0])}
        }
        return sorted;
    }
    commonSort = (rec,from) =>{
        if(from === "history"){
            for(let s of rec){                
                for(let e of s.series){
                    this.historySort(e,"history");
                }
            }
            return rec;
        }else{
            if(rec.series.length>1){
                let index = rec.series.findIndex(x=>x.flag.toLowerCase() === constants.transcriptHistory.future);
                if(index === 0){rec.series.reverse();}
            } 
            for(let s of rec.series){
                if(s.examSeries.length>1){                    
                    this.historySort(s,"summary");
                }
            }            
            this.setState({overlay:!this.state.overlay,record:rec});
        }
    }
    historySort = (e,path) =>{
        // Patch: Do not deduplicate or filter identical series, just preserve the original order
        // This ensures all series, even duplicates, are displayed in the modal
        // If you want to sort, do so without removing duplicates
        if (e.examSeries?.length > 1) {
            // Optionally, sort by session/year if needed, but do not deduplicate
            e.examSeries = [...e.examSeries];
        }
    }
    navToPersonalInfo = () => {
        this.props.updateTranscriptHistoryFlag();
        if(this.props.stateNavFlags.isHistoryPayNav){
            this.props.resetStateTransitionFlags();
        }
        if(!isEmpty(this.props.nameFromHistory.fNameFromHistory)){
            this.props.setNamesFromHistoryAndModified({fName:'',lName:''});
        }     
        this.props.history.push('/personal-information');
    }
    statusLinkNav = (rec,i) =>{
        const {payNowLink,viewSummaryLink} = constants.transcriptHistory,
              status = rec.series[i].status?.toLowerCase().replace(/\s/g, ''),
              payNow = payNowLink.filter(s=>s === status),
              viewSummary = isEmpty(payNow)?viewSummaryLink.filter(v=>v === status):"",
              rate = this.props.transcriptRates?.transcriptsCost?.filter(r=>r.countryCode === 'US');

        this.props.setTotalTranscriptAmount(rec.institutions.length * rate[0].amount);
        if(!isEmpty(payNow)){
            const args = { payload: {
                data: {applicationReferenceNumber: rec.applicationReferenceNumber, paymentDueDate: rec.paymentDueDate, transactionId: rec.orderId}
            }}
            MulesoftDataService.validatePaymentDue(args)
            .then(res => {
                if(res.data.breached === true) {
                    this.setState({
                        overlay: true,
                        record: 'paymentDue'
                    })
                }
                else {
                    this.props.setNamesFromHistoryAndModified({fName:rec.firstName,lName:rec.lastName});            
                    this.props.getInstitutionsError();
                    this.props.getExamSeriesSuccess(rec.series[i].examSeries);
                    this.props.getInstitutionsSuccess(rec.institutions);
                    this.props.setRequestId({requestId:rec.applicationReferenceNumber, paymentDueDate: rec.paymentDueDate, applicationSubmittedDate: rec.orderInsertedDate});            
                    this.props.updatePayFlag();
                    this.props.updateHistoryPayNavFlag();           
                    this.props.history.push('/acceptTerms'); 
                }
            })
        }else if(!isEmpty(viewSummary) && rec.applicationReferenceNumber){            
            this.props.getTranscriptSummary({appRefNum:rec.applicationReferenceNumber,tId:uuidv4()});
        }else{
            this.setState({overlay:!this.state.overlay,record:null});
        }
    }    
    getScores(rec,i){
        this.setState({spinner: true});        
        if(!isEmpty(rec.series[i].scores)){
            let arr=[];
            for(let s of rec.series[i].examSeries){
                let sIndex = rec.series[i].scores.examSeries.findIndex(x=>x.series === s.session);
                if(sIndex>=0){
                    arr.push(rec.series[i].scores.examSeries[sIndex]);
                }
            }
            rec.series[i].scores.examSeries = arr;
            rec.series[i].section = "scores";
        }        
        this.setState({overlay:!this.state.overlay,record:rec.series[i],spinner:false});
    }  
    hideModal = () => {
        this.setState({overlay:!this.state.overlay})
        this.setState({spinner: true});
        this.loadHistory();
    };
    render(){
        const {body,overlay,record,spinner,errorMsg} = this.state, 
              {headers,labels,noData,statusLinks,statuslabels,viewScore,availability,future} = constants.transcriptHistory;
        const currentDate = new Date();  
        return(
            <>{ this.props.isUserLoggedIn &&
            <React.Fragment>
                <div id='history-page'>
                    {spinner && 
                    <Spinner animation="grow" size="xl" role="status" className="elem-to-center">
                        <span className="sr-only">Loading...</span>
                    </Spinner>}               
                    <div className='row p-3 btn-content'>
                        <h2 className='font-weight-bold'>{labels?.header}</h2>
                        <button id='navToPersonal' type="button" onClick={this.navToPersonalInfo} className="btn font-weight-bold save-button-review text-white newTransBtn ml-5">{labels?.btn}</button>
                    </div>
                    <>{ this.props.mobileDevice?
                        <div className="card">
                            <div className="card-body">
                                {body?.length>0 ? body.map((r,i)=>{
                                    if(r.series.length>1){
                                        let index = r.series.findIndex(x=>x.flag.toLowerCase() === future);
                                        if(!index){r.series.reverse();}
                                    }
                                    const orderInsertedDate = UtilityService.convertUTCDateTimetoLocalDateTime(r.orderInsertedDate)
                                    const paymentDueDate = UtilityService.convertUTCDateTimetoLocalDateTime(r.paymentDueDate) 
                                    return(r.applicationReferenceNumber &&
                                        <div key={r.orderId} className="border border-secondary rounded col-12 col-lg-5 col-sm-6 col-md-5 mb-4">
                                            <p><label className='mb-0 mt-2 field-color font-weight-bold'>Application submitted date &ensp;</label><span className='italic field-color'>{orderInsertedDate && moment(orderInsertedDate).format('DD MMMM yyyy')}</span></p>
                                            <p><label className='mb-0 mt-1 field-color font-weight-bold'>Payment due date &ensp;</label><span className='italic field-color'>{paymentDueDate && moment(paymentDueDate).format('DD MMMM yyyy')}</span></p>
                                            <p><label className='mb-0 mt-1 field-color font-weight-bold'>Payment date &ensp;</label><span className='italic field-color'>{r.paymentDate && moment(r.paymentDate).format('DD MMMM yyyy')}</span></p>
                                            <div className="head-label mr-2">Exam(s)</div>                        
                                                                                        {r.series && r.series.map((e, i) => (
                                                                                            <div key={i}>
                                                                                                {Array.isArray(e.examSeries)
                                                                                                    ? e.examSeries.map((s, j) => <p className={j>=1?"txtNoWrap mt-1 mb-0":"txtNoWrap mb-0"} key={j}>{s.session || s}</p>)
                                                                                                    : <p>{e.examSeries}</p>
                                                                                                }
                                                                                                {e.scores && e.scores.examSeries && e.scores.examSeries.length > 0 && (() => {
                                                                                                    const endDate = new Date(e.scores.examSeries[0].gradeAvailableEndDate);
                                                                                                    const scoreLink = currentDate.getTime() <= endDate.getTime();
                                                                                                    return scoreLink && (
                                                                                                        <p className="pointer mb-0">
                                                                                                            <a id={i} role="button" onClick={()=> this.getScores(r,i)}><b>{viewScore}</b><br/>
                                                                                                                <span><em>{availability} {moment(e.scores.examSeries[0].gradeAvailableEndDate).format('DD MMMM yyyy')+")"}</em></span>
                                                                                                            </a>
                                                                                                        </p>
                                                                                                    );
                                                                                                })()}
                                                                                            </div>
                                                                                        ))}
                                            <p><label className='mb-0 mt-4 field-color font-weight-bold'>Order number &ensp;</label><span className='field-color'>{r.applicationReferenceNumber}</span></p>
                                            <div className="head-label mr-2 mt-4">Status</div>
                                                                                        {r.series && r.series.map((e, i) => (
                                                                                            <p key={i}>{e.status || e.applicationStatus || ''}</p>
                                                                                        ))}
                                            <div className="head-label mr-2 mt-4">Institution(s)</div>                        
                                            {r.institutions && r.institutions.map((e,i)=> { return(<p key={i}>{e.replace(/[,]/g,',  ')}</p>)})}                                            
                                            {r.series && r.series.map((e,i)=>{
                                                let status = e.status && statuslabels.filter(s=>s === e.status.toLowerCase().replace(/\s/g, '')),
                                                link = status && statusLinks[status[0]];
                                                return(link && status !== statuslabels[4] && status !== statuslabels[5] && e.flag.toLowerCase() !== future &&
                                                        <p className={link?'txtNoWrap pointer':'txtNoWrap'}>{link && <a id={i+1} role="button" onClick={()=>this.statusLinkNav(r,i)}>{link}</a>}</p>
                                                        )})}                                      
                                        </div>)
                                    }):!spinner &&  <span className='italic'>&nbsp;{noData}</span>
                                }                
                            </div>
                        </div>:
                        <div className="card">
                            {body?.length>0 ?
                                <table className="table border rounded"> 
                                    <thead><tr>{headers?.length>0 && headers.map((h,i)=><th scope='col' key={i}>{h}</th>)}</tr></thead>
                                        <tbody>{body.map((r,mainIndex)=>{
                                        if(r.series.length>1){
                                            let index = r.series.findIndex(x=>x.flag.toLowerCase() === future);
                                            if(index === 0){r.series.reverse();}
                                        }
                                        const orderInsertedDate = UtilityService.convertUTCDateTimetoLocalDateTime(r.orderInsertedDate) 
                                        const paymentDueDate = UtilityService.convertUTCDateTimetoLocalDateTime(r.paymentDueDate)                                                                                        
                                        return(r.applicationReferenceNumber && <tr key={r.orderId}>
                                                <td>{orderInsertedDate && moment(orderInsertedDate).format('DD MMMM yyyy')}</td>
                                                <td>{paymentDueDate && moment(paymentDueDate).format('DD MMMM yyyy')}</td>
                                                <td>{r.paymentDate && moment(r.paymentDate).format('DD MMMM yyyy')}</td>
                                                                                                <td>
                                                                                                    {r.series && r.series.map((e, i) => (
                                                                                                        <div key={i}>
                                                                                                            {Array.isArray(e.examSeries)
                                                                                                                ? e.examSeries.map((s, j) => <p className={j>=1?"mt-1 mb-0":"mb-0"} key={j}>{s.session || s}</p>)
                                                                                                                : <p>{e.examSeries}</p>
                                                                                                            }
                                                                                                            {e.scores && e.scores.examSeries && e.scores.examSeries.length > 0 && (() => {
                                                                                                                const endDate = new Date(e.scores.examSeries[0].gradeAvailableEndDate);
                                                                                                                const scoreLink = currentDate.getTime() <= endDate.getTime();
                                                                                                                return scoreLink && (
                                                                                                                    <p className="pointer mb-0">
                                                                                                                        <a id={i} role="button" onClick={()=> this.getScores(r,i)}><b>{viewScore}</b><br/>
                                                                                                                            <span><em>{availability} {moment(e.scores.examSeries[0].gradeAvailableEndDate).format('DD MMMM yyyy')+")"}</em></span>
                                                                                                                        </a>
                                                                                                                    </p>
                                                                                                                );
                                                                                                            })()}
                                                                                                        </div>
                                                                                                    ))}
                                                                                                </td>
                                                <td>{r.applicationReferenceNumber}</td>
                                                                                                <td>
                                                                                                    {r.series && r.series.map((e, i) => (
                                                                                                        <p className={i>=1?"":"mb-0"} key={i}>{e.status || e.applicationStatus || ''}</p>
                                                                                                    ))}
                                                                                                </td>
                                                <td>{r.institutions && r.institutions.map((e,i)=> { return(<p key={i}>{e.replace(/[,]/g,',  ')}</p>)})}</td>                                                                                           
                                                <td>
                                                    {r.series && r.series.map((e,i)=>{
                                                        let status = e.status && statuslabels.filter(s=>s === e.status.toLowerCase().replace(/\s/g, '')),
                                                        link = status && statusLinks[status[0]];
                                                       return(link && status !== statuslabels[4] && status !== statuslabels[5] && e.flag.toLowerCase() !== future &&
                                                            <>  
                                                                {i>0 && r.series[i-1].examSeries.map((s,j)=>{return(j>0 && <p className="invisible mt-1 mb-0" key={j}>&nbsp;</p>)})}
                                                                {i>0 && r.series[i-1].scoreLink && <p className="invisible mt-4">&nbsp;</p>}
                                                                <p className={i>=1?"pointer text-decoration-none":"pointer text-decoration-none mb-4"}>
                                                                    <a id={i+1} key={i} role="button" onClick={()=>this.statusLinkNav(r,i)}><span>{link}</span></a>
                                                                </p>
                                                                {i>1 && <p className='invisible mb-0'>&nbsp;</p>}
                                                            </>)})}
                                                </td>
                                            </tr>)})}                                                              
                                        </tbody>
                            </table>
                                :<div>
                                    <table className="table border rounded"> 
                                        <thead><tr>{headers?.length>0 && headers.map((h,i)=><th scope='col' key={i}>{h}</th>)}</tr></thead>                        
                                    </table>
                                    {body?.length === 0?<span className='italic ml-2'>&nbsp;{noData}</span>:
                                                        <span className='italic ml-2'>&nbsp;{errorMsg?errorMsg:""}</span>}
                                </div>
                            }                                                           
                        </div>                    
                      }</>
                </div>
                <div id='printModalContent'>                
                    <Modal show={overlay} hideModal={this.hideModal} rec={record} mobile={this.props.mobileDevice} />
                </div>
            </React.Fragment>
            }</>
        );
    }
}
const mapStateToProps = state => {
    return{        
        userProfile: state.currentUser.profile,
        nameFromHistory: state.currentUser,
        isUserLoggedIn: state.currentUser.isUserLoggedIn,
        transcriptRates : state.reviewConfirm,
        stateNavFlags : state.stateTransition,
        mobileDevice: state.commonData.mobileDevice,
        transactionId: state.commonData.transactionId,
        tHistory: state.transcriptHistory,
        terms : state.termsAndConditionsReducer.conditionsApiText
    };
};
const mapDispachToProps = {    
    updateTranscriptHistoryFlag,
    setTransactionHistorySuccess,
    getExamSeriesSuccess,
    getInstitutionsSuccess,
    getTranscriptsCost,
    updatePayFlag,
    setTotalTranscriptAmount,
    getInstitutionsError,
    setRequestId,
    updateHistoryPayNavFlag,
    resetStateTransitionFlags,
    setDeviceType,
    getTranscriptHistory,
    getTranscriptSummary,
    getTermsAndConditions,
    resetHistoryFlags,
    resetCommonDataData,
    setNamesFromHistoryAndModified
};
export default withRouter(connect(mapStateToProps,mapDispachToProps)(TranscriptHistory));